<!-- Spinner while catalog is being loaded -->
<div *ngIf="loading && !loadError" class="pd-loader">
    <hc-progress-spinner color="purple" [diameter]="75"></hc-progress-spinner>
</div>

<!-- Error loading content -->
<div *ngIf="!loading && loadError" class="pd-permission-error">
    <hc-icon fontSet="fa" fontIcon="fa-warning"></hc-icon>
    There was an error loading sources. Click below try again.
    <button hc-button size="lg" (click)="loadSources()">Reload Sources</button>
</div>

<div class="admin-product-catalog-table-container" [hidden]="loadError || loading">
    <h2>
        <span>
            <hc-icon fontSet="hc-icons" fontIcon="hci-binding" class="sources-icon"></hc-icon>
            Sources
        </span>
        <div>
            <button hc-button routerLink="/admin/sources/editor">Add Source</button>
            <button hc-button buttonStyle="minimal" id="menu-button" [hcPop]="editMenu">
                <hc-icon fontSet="fa" fontIcon="fa-ellipsis-v"></hc-icon>
            </button>
            <hc-pop #editMenu [autoCloseOnContentClick]="true" [showArrow]="false" horizontalAlign="end">
                <div hcMenu>
                    <button hcMenuItem (click)="openStringEditor('Type')">
                        <span hcMenuText><hc-icon hcMenuIcon fontSet="fa" fontIcon="fa-pencil"></hc-icon>Edit source types</span>
                    </button>
                </div>
            </hc-pop>
        </div>
    </h2>
    <div class="admin-product-catalog-control-bar">
        <div class="admin-product-catalog-filters">
            <div class="filter-dropdown" title="Filter by type">
                <label for="productLine">Type</label>
                <button hc-button buttonStyle="link-inline" id="type" [hcPop]="filtermenu"
                    (click)="storeFilterData('type')" [context]="typeFilters">
                    <span class="value hc-text-ellipsis filter-dropdown-length">{{ typeText }}</span>
                    <hc-icon fontSet="fa" fontIcon="fa-chevron-down" hcIconSm></hc-icon>
                </button>
            </div>
            <div class="filter-dropdown" title="Filter by product status">
                <label for="productStatus">Status</label>
                <button hc-button buttonStyle="link-inline" id="productStatus" [hcPop]="filtermenu"
                    (click)="storeFilterData('status')" [context]="statusFilters">
                    <span class="value hc-text-ellipsis filter-dropdown-length">{{ statusText }}</span>
                    <hc-icon fontSet="fa" fontIcon="fa-chevron-down" hcIconSm></hc-icon>
                </button>
            </div>
            <hc-pop #filtermenu scrollStrategy="close" (opened)="filterSelections = $event">
                <filter-popover [filterData]="filterData" [setVals]="filterSelections" (close)="filtermenu.close()"
                    (filterChecked)="storeFilterArray($event)"></filter-popover>
            </hc-pop>
        </div>
        <div class="control-bar-right">
            <hc-search-bar #searchbar placeholder="Search sources" (triggerSearch)="applySearchFilter($event)"
                class="admin-product-catalog-search"></hc-search-bar>
        </div>
    </div>
    <table hc-table [borders]="false" class="admin-product-catalog-table" [dataSource]="dataSource" hcSort>
        <!-- ID Column -->
        <ng-container hcColumnDef="item">
            <th hc-index-cell *hcHeaderCellDef hc-sort-header id="item">ID</th>
            <td hc-index-cell *hcCellDef="let element" routerLink="/admin/sources/editor" [queryParams]="{id: element.sourceID}">{{ element.item }}</td>
        </ng-container>

        <!-- Name Column -->
        <ng-container hcColumnDef="name">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="nameHeader">Name</th>
            <td hc-cell *hcCellDef="let element" routerLink="/admin/sources/editor" [queryParams]="{id: element.sourceID}">{{ element.name }}</td>
        </ng-container>

        <!-- Type Column -->
        <ng-container hcColumnDef="type">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="typeHeader">Type</th>
            <td hc-cell *hcCellDef="let element" routerLink="/admin/sources/editor" [queryParams]="{id: element.sourceID}">{{ element.type }}</td>
        </ng-container>

        <!-- Status Column -->
        <ng-container hcColumnDef="status">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="statusHeader">Status</th>
            <td hc-cell *hcCellDef="let element" routerLink="/admin/sources/editor" [queryParams]="{id: element.sourceID}">{{ element.status }}</td>
        </ng-container>

        <!-- Revision Date Column -->
        <ng-container hcColumnDef="revisionDate">
            <th hc-header-cell *hcHeaderCellDef hc-sort-header id="revisionDateHeader">Revision Date</th>
            <td hc-cell *hcCellDef="let element" routerLink="/admin/sources/editor" [queryParams]="{id: element.sourceID}">{{ element.revisionDate | date: 'shortDate' }}</td>
        </ng-container>

        <tr hc-header-row *hcHeaderRowDef="adminSourcesDisplayedColumns"></tr>
        <tr hc-row *hcRowDef="let row; columns: adminSourcesDisplayedColumns"></tr>
    </table>

    <div class="hc-empty-table-block" *ngIf="dataSource.filteredData.length === 0">
        <span class="hc-empty-table-block-ico hc-empty-ico"></span>
        <span class="hc-empty-table-block-msg">No sources meet your search criteria.</span>
    </div>

    <hc-pagination [length]="adminSourcesListLength" [pageSize]="adminSourcesPageSize" [hidden]="loadError || loading"></hc-pagination>
</div>